import { AppState } from '../AppTypes';

const isDevAndNotTest = import.meta.env.DEV && !import.meta.env.VITEST;

export const _getFlagVariation = (state: AppState) => {
  return (flag: string, defaultValue?: any) => {
    if (isDevAndNotTest) {
      return state.flags?.includes(flag);
    }
    return state.ldClient.variation(flag, defaultValue);
  };
};
